import React, { useState } from 'react'

import * as MdIcons from 'react-icons/md'
import { useTheme } from 'styled-components'

import { FormSelect } from '@components/Form/FormSelect'
import { Separator } from '@components/Separator'
import { SheetModal } from '@components/SheetModal'
import { useSetFilters } from '@hooks/filters'
import { useFindProfile } from '@hooks/profile'
import { useSiteFeatures } from '@hooks/siteFeatures'

import { useFilterModels } from '../models'
import { FilterMultiselect } from '../Multiselect'
import { ResetFilters } from './Reset'
import {
  BottomContainer,
  Container,
  FilterOptionContainer,
  OptionLabel,
  PressableContainer,
  SelectedOptionLabel,
} from './styles'
interface IFilterData {
  description: string
  id: number
}

interface IFilterPayload {
  statusIds?: number[]
  areaIds?: number[]
  locationIds?: number[]
  supervisorIds?: number[]
  resourceIds?: number[]
  plantSectionIds?: number[]
  operationPostIds?: number[]
  assigneeIds?: number[]
  projectIds?: number[]
}

interface IFilterModel {
  label: string
  options: IFilterData[]
  selected: IFilterData[]
  payloadOption: keyof IFilterPayload
}

interface IFilters {
  status?: IFilterModel
  areas?: IFilterModel
  locations?: IFilterModel
  supervisors?: IFilterModel
  resources?: IFilterModel
  plantSections?: IFilterModel
  operationPosts?: IFilterModel
  assignees?: IFilterModel
  projects?: IFilterModel
}

export function FiltersContainer() {
  const { colors } = useTheme()
  const { data: user } = useFindProfile()
  const { getFilterModel } = useFilterModels()
  const { isMidstreamProcess } = useSiteFeatures()

  const [isMultiselectSheetOpen, setIsMultiselectSheetOpen] = useState(false)
  const [multiselectOptions, setMultiselectOption] = useState<IFilterModel>(
    {} as IFilterModel,
  )

  const filterModel = getFilterModel()

  const savedFilters = user && user.selectedSite.filters

  const { mutateAsync: postSelectedFilters } = useSetFilters()

  const supervisorRoles = [
    {
      label: 'Lead Supervisor',
      value: 0,
    },
    {
      label: 'Responsible Supervisor',
      value: 1,
    },
  ]

  Object.entries(filterModel).forEach((row) => {
    const key = row[0] as keyof IFilters
    const val = row[1] as IFilterModel

    const savedFilter = savedFilters && savedFilters[`${val.payloadOption}`]

    if (savedFilter && filterModel[key]) {
      filterModel[key]!.selected = savedFilter?.map((model: any) =>
        val.options.find((option) => option.id === model),
      ).filter(Boolean) as any
    }
  })

  function handleSaveFilters({
    payloadOption,
    selectedOptions,
  }: {
    payloadOption: string
    selectedOptions: IFilterData[]
  }) {
    if (savedFilters) {
      savedFilters[`${payloadOption}` as keyof IFilterPayload] =
        selectedOptions.map((option) => option.id)
    }
  }

  function handleSetFilters() {
    if (savedFilters) postSelectedFilters(savedFilters)
    setIsMultiselectSheetOpen(false)
  }

  function handleSaveSupervisorRole(itemValue: string) {
    if (savedFilters) {
      savedFilters.supervisorRole = Number(itemValue) as 0 | 1
      postSelectedFilters(savedFilters)
    }
  }

  return (
    <>
      <Container>
        {(Object.values(filterModel) as IFilterModel[]).map((item, index) => (
          <React.Fragment key={item.payloadOption}>
            {index > 0 && <Separator />}
            <PressableContainer
              onClick={() => {
                setIsMultiselectSheetOpen(true)
                setMultiselectOption(item)
              }}
            >
              <FilterOptionContainer>
                <OptionLabel>{item.label}</OptionLabel>
                <MdIcons.MdKeyboardArrowDown
                  size={23}
                  color={colors.text}
                />
              </FilterOptionContainer>
              {item.selected &&
                item.selected.map((selectedFilterOption) => (
                  <SelectedOptionLabel key={selectedFilterOption?.id}>
                    {`- ${selectedFilterOption?.description}`}
                  </SelectedOptionLabel>
                ))}
            </PressableContainer>
          </React.Fragment>
        ))}
      </Container>

      <BottomContainer>
        {!isMidstreamProcess && (
          <FormSelect
            items={supervisorRoles}
            defaultValue={savedFilters?.supervisorRole.toString()}
            onValueChange={handleSaveSupervisorRole}
          />
        )}
        <ResetFilters />
      </BottomContainer>

      <SheetModal
        initialSnap={4}
        open={isMultiselectSheetOpen}
        onClose={handleSetFilters}
      >
        <FilterMultiselect
          data={multiselectOptions}
          onChange={handleSaveFilters}
        />
      </SheetModal>
    </>
  )
}
